import { digitosTelefone, linkWhatsapp, textoDoConvite } from '../utils';

interface Props {
  eventoId: number;
  familias: { responsavel: string; telefone: string | null }[];
}

// Quem marcou "vai levar filhos" e ainda não disse quem são.
export default function FamiliasSemDados({ eventoId, familias }: Props) {
  if (familias.length === 0) return null;

  const texto = textoDoConvite(eventoId);

  return (
    <section className="mt-5">
      <h2 className="px-1 text-[15px] font-bold text-foreground-950">
        Ainda não disseram quem são
      </h2>
      <p className="mt-1 px-1 text-[13px] text-foreground-600">
        Marcaram que vão levar filhos, mas ainda não preencheram os dados. Mande o link de novo.
      </p>

      <div className="mt-2 space-y-2">
        {familias.map((familia, indice) => {
          const zap = linkWhatsapp(familia.telefone, texto);
          const temFone = digitosTelefone(familia.telefone).length >= 10;
          return (
            <div
              key={`${familia.responsavel}-${indice}`}
              className="flex min-h-[56px] items-center gap-3 rounded-2xl border border-background-200 bg-white px-4 py-3"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-warning-50 text-warning-800">
                <i className="ri-user-line" aria-hidden />
              </span>
              <p className="min-w-0 flex-1 truncate text-[14px] font-semibold text-foreground-950">
                {familia.responsavel}
              </p>
              {zap && temFone ? (
                <a
                  href={zap}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-11 shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-success-600 px-3 text-[13px] font-semibold text-white transition-colors hover:bg-success-700"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-whatsapp-line" aria-hidden />
                  </span>
                  Mandar link
                </a>
              ) : (
                <span className="shrink-0 whitespace-nowrap text-[12px] text-foreground-500">
                  sem telefone
                </span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}